<template>
    <Upload
        ref="upload"
        :show-upload-list="false"
        :on-success="handleSuccess"
        :format="format"
        :max-size="102400"
        :action="fileUrl"
        :data="uploadData"
        :headers="header"
        :before-upload="beforeUpload"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleMaxSize"
        type="drag"
        style="display: inline-block;">
        <Button type="primary">上传文件</Button>
    </Upload>
</template>

<script>
    import Setting from "@/setting";
    import util from "@/libs/util";
    export default {
        name: "upload-file",
        props: {
            format: {
                type: Array,
                default: []
            },
            type: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                fileUrl: this.app_url + "/store/uploader/fileUpload",
                header: {
                },
                uploadData: {
                },
            }
        },
        mounted() {
            this.getUniacid();
            this.getToken();
        },
        methods: {
            // 上传头部token
            getUniacid() {
                // this.uniacid = util.cookies.get("uniacid");
            },
            // 上传头部token
            getToken() {
                // this.header["Authori-zation"] = "Bearer " + util.cookies.get("token");
            },
            // 上传之前
            beforeUpload() {
                this.uploadData = {
                    filetype: this.type
                };
                let promise = new Promise((resolve) => {
                    this.$nextTick(function () {
                        resolve(true);
                    });
                });
                return promise;
            },
            handleFormatError (file) {
                this.$Notice.warning({
                    title: '文件格式不正确',
                    desc: '文件 ' + file.name + ' 格式不正确，请上传 正确的文件格式。'
                });
            },
            handleMaxSize (file) {
                this.$Notice.warning({
                    title: '超出文件大小限制',
                    desc: '文件 ' + file.name + ' 太大，不能超过 100M。'
                });
            },
            // 上传成功
            handleSuccess(res, file, fileList) {
                if (res.code === 1) {
                    this.$emit("uploadSuccess", res.data.fileInfo);
                }
            },
        }
    }
</script>

<style scoped>

</style>
